<template>
  <div v-if="showBannerCond" class="container-banner" :class="variant" :role="variant !== 'box-white' ? 'banner' : null" :tabindex="variant !== 'box-white' ? '-1' : null">
    <div :class="['banner',  { voucher: useVoucher }, { link: useLink }]">
      <span v-if="useInfoIcon" :class="['banner-info']">
        <slot name="txtInfo"></slot>
        <button v-if="useInfoIcon" :class="['icon-only']" @click="openOverlay()">
          <span class="banner-info-icon"><img src="files/flash/images/svg-icons/info-icon-white.svg" :aria-label="getSlotText('txtInfoIconAriaLabel')" :alt="getSlotText('txtInfoIconAlt')"></span>
        </button>
      </span>
      <span v-if="!useInfoIcon" :class="['banner-info']">
        <slot name="txtInfo"></slot>
      </span>
      <span v-if="useLink"><a :href="linkUrl" :target="linkNewTab? '_blank': ''" :aria-label="getSlotText('txtLinkAriaLabel')">{{linkText}}</a></span>
      <span :class="['banner-voucher']" v-if="useVoucher" >
        <slot name="txtPreVoucher"></slot>
        <button v-if="useVoucherCopy || useVoucherAdd" :class="['icon-with-text', useVoucherUnderline? 'underline' : '']" @click="handleVoucherClick(getSlotText('txtVoucher'))">
          <span class="icon-with-text__icon"><img src="files/flash/images/svg-icons/icon-copy-white.svg" :aria-label="getSlotText('txtVoucherAriaLabel')" :alt="getSlotText('txtVoucherAlt')"></span>
          <span class="icon-with-text__text"><slot name="txtVoucher"></slot></span>
        </button>
        <span v-if="!useVoucherCopy && !useVoucherAdd">
          <span :class="useVoucherUnderline? 'underline' : ''" ><slot name="txtVoucher"></slot></span>
        </span>
      </span>
      <div v-if="useCountdown && !countdownExpired" class="countdown-divider"></div>
      <div v-if="useCountdown && !countdownExpired" class="countdown-numbers">
        <div class="countdown-days countdown-units">
          <div class="countdown-digits">{{ dayDiff }}</div>
          <div class="countdown-label"><slot name="txtCountdownDays">Tagen</slot></div>
        </div>
        <div class="countdown-hours countdown-units">
          <div class="countdown-digits">{{ hourDiff }}</div>
          <div class="countdown-label"><slot name="txtCountdownHours">Stunden</slot></div>
        </div>
        <div class="countdown-minutes countdown-units">
          <div class="countdown-digits">{{ minuteDiff }}</div>
          <div class="countdown-label"><slot name="txtCountdownMinutes">Minuten</slot></div>
        </div>
        <div class="countdown-second countdown-units">
          <div class="countdown-digits">{{ secondDiff }}</div>
          <div class="countdown-label"><slot name="txtCountdownSeconds">Sekunden</slot></div>
        </div>
      </div>
      <SimonModal
        v-if="useInfoIcon"
        :is-visible="showOverlay"
        @hide="showOverlay = false"
        :btn-cancel-title="getSlotText('txtModalCloseButton')"
      >
        <template v-slot:modalTitle>
          <slot name="headerModal">
            <h3><slot name="txtInfoModalHeadline"></slot></h3>
          </slot>
        </template>
        <div class="banner-modal--body"><slot name="txtInfoModalText"></slot></div>
      </SimonModal>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'
import { isReducedMotion } from '@/helper/accessibility.js'

export default {
  name: 'BannerWithCountdown',
  components: { SimonModal },
  props: {
    variant: {
      type: String,
      default: 'banner-red',
      validator: function (value) {
        return ['banner-red', 'banner-violet', 'box-white', 'banner-mint'].includes(value)
      }
    },
    showOnlyReturners: {
      type: Boolean,
      default: false
    },
    useInfoIcon: {
      type: Boolean,
      default: false
    },
    useVoucher: {
      type: Boolean,
      default: false
    },
    useVoucherCopy: {
      type: Boolean,
      default: false
    },
    useVoucherAdd: {
      type: Boolean,
      default: false
    },
    useVoucherUnderline: {
      type: Boolean,
      default: false
    },
    useCountdown: {
      type: Boolean,
      default: false
    },
    enddate: {
      type: String,
      default: '3000-01-01T00:00:00+01:00',
      validator: function (value) {
        return Date.parse(value.replace(/(<([^>]+)>)/gi, '')) > 0
      }
    },
    useLink: {
      type: Boolean,
      default: false
    },
    linkText: {
      type: String,
      default: ''
    },
    linkUrl: {
      type: String,
      default: ''
    },
    linkNewTab: {
      type: Boolean,
      default: false
    },
    txtLinkAriaLabel: {
      type: String,
      default: ''
    },
    txtInfoIconAriaLabel: {
      type: String,
      default: ''
    },
    txtVoucherAriaLabel: {
      type: String,
      default: ''
    },
    txtInfoIconAlt: {
      type: String,
      default: ''
    },
    txtVoucherAlt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showBanner: true,
      showOverlay: false,
      countdownExpired: true,
      countdownEndDate: new Date(this.enddate.replace(/(<([^>]+)>)/gi, '')).getTime(),
      dayDiff: '00',
      hourDiff: '00',
      minuteDiff: '00',
      secondDiff: '00'
    }
  },
  computed: {
    ...mapGetters('promotion/promoCode', [
      'couponRedeemed'
    ]),
    ...mapGetters('checkoutv2/ordering/_cart', ['voucherCode']),
    showBannerCond: function () {
      if (this.useVoucherAdd && (this.couponRedeemed || this.voucherCode)) {
        return false
      }
      return this.showBanner
    },
    hasMarketingConsent: function () {
      let ret = false
      if (window.cookieNS && window.cookieNS.main && window.cookieNS.main.getCookie) {
        const optanonConsentCookie = window.cookieNS.main.getCookie('OptanonConsent')
        // Wanted part of the cookie looks something like this: groups=1:1,2:1,4:1,5:1,V2STACK8:1,V2STACK16:1
        const parts = optanonConsentCookie.split('groups=').pop().split('&').shift().split(',')
        parts.forEach((entry) => {
          entry = entry.replace('C000', '')
          // '4:1' -> Has Marketing consent, otherwise '4:0'
          if (entry === '4:1') {
            ret = true
          }
        })
      }
      return ret
    }
  },
  mounted () {
    if (this.useCountdown) {
      this.timerCount()
    }
    const probingCookie = window.cookieNS.main.getCookie('probing')
    if (probingCookie) {
      // Disabled for probing because it creates conflicts
      this.showBanner = false
      return
    }
    if (this.showOnlyReturners) {
      if (!this.hasMarketingConsent) {
        this.showBanner = false
        return
      }
      // Cookie that marks retruners -> '1' for returner - is first set after this code runs, thus the ts check below
      const dipRetCookie = parseInt(window.cookieNS.main.getCookie('dip_ret_cookie')) || 0
      if (dipRetCookie !== 1) {
        // Check manually for the s_nr cookie, because dip_ret_cookie might be wrong on first load
        // External cookie with a timestamp managed by Digital Power via Adobe Analytics
        // If the tomestamp is older than 30 minutes and younger than 30 days -> returner
        const tsCookie = parseInt(window.cookieNS.main.getCookie('s_nr')) || 0
        // Cookie with login count - only show banner if this is 0
        const loginCountCookie = parseInt(window.cookieNS.main.getCookie('dip_login_count')) || 0
        const ts30min = (new Date()) - (30 * 60 * 1000)
        const ts30days = (new Date()) - (30 * 24 * 60 * 60 * 1000)
        if (loginCountCookie > 0 || tsCookie > ts30min || tsCookie < ts30days) {
          this.showBanner = false
        }
      }
    }
    if (this.showBannerCond) {
      document.body.classList.add('banner')
    }
  },
  watch: {
    showBannerCond: {
      immediate: true,
      handler: function (newValue) {
        if (newValue && !document.body.classList.contains('banner')) {
          document.body.classList.add('banner')
        } else if (!newValue && document.body.classList.contains('banner')) {
          document.body.classList.remove('banner')
        }
      }
    }
  },
  methods: {
    openOverlay () {
      if (this.useInfoIcon) {
        this.showOverlay = true
      }
    },
    handleVoucherClick (voucherTxt) {
      let tryCopyInstead = false
      if (this.useVoucherAdd && window.kk && typeof window.kk.addVoucherCode === 'function') {
        window.kk.addVoucherCode(voucherTxt, res => {
          if (res) {
            // Open Mobile Shopping Cart if in mobile view
            const mobileCartElement = document.getElementsByClassName('app-checkout-shoppingcart-mobile-wrapper')[0]
            if (mobileCartElement && mobileCartElement.offsetParent !== null) {
              document.getElementById('drawerPlaceholder').click()
            }
          }
        })
      } else if (this.useVoucherAdd) {
        const checkoutCta = document.querySelector('[data-prid=\'button-checkout\']')
        if (checkoutCta && !checkoutCta.href.includes(voucherTxt)) {
          checkoutCta.href = checkoutCta.href + '?promoCode=' + voucherTxt
        } else {
          tryCopyInstead = true
        }
      }
      if (this.useVoucherCopy || tryCopyInstead) {
        try {
          // Webview Handling
          if (window.WebView !== undefined && (window.isIOS === undefined || window.isIOS === false)) {
            if (window.App !== undefined && window.App.copyToClipBoard !== undefined) {
              window.App.copyToClipBoard(voucherTxt)
              this.successToast(this.getSlotText('txtCopySuccessToast', 'Die Information wurde in die Zwischenablage kopiert!'))
            }
          } else {
            navigator.clipboard.writeText(voucherTxt).then(() => {
              this.successToast(this.getSlotText('txtCopySuccessToast', 'Die Information wurde in die Zwischenablage kopiert!'))
            }).catch(() => {
              this.errorToast(this.getSlotText('txtCopyErrorToast', 'Hoppla, da ist was schief gelaufen!'))
            })
          }
        } catch (err) {
          this.errorToast(this.getSlotText('txtCopyErrorToast', 'Hoppla, da ist was schief gelaufen!'))
        }
      }
    },
    timerCount () {
      const computeTime = () => {
        const currentDate = new Date().getTime()
        const dateDifferenceEnddate = this.countdownEndDate - currentDate
        if (dateDifferenceEnddate >= 0) {
          this.dayDiff = this.addLeadingZero(Math.floor(dateDifferenceEnddate / (1000 * 60 * 60 * 24)))
          this.hourDiff = this.addLeadingZero(Math.floor(dateDifferenceEnddate % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
          this.minuteDiff = this.addLeadingZero(Math.floor(dateDifferenceEnddate % (1000 * 60 * 60) / (1000 * 60)))
          this.secondDiff = this.addLeadingZero(Math.floor(dateDifferenceEnddate % (1000 * 60) / (1000)))
          this.countdownExpired = false
        } else {
          this.countdownExpired = true
        }
      }

      computeTime()

      if (!isReducedMotion || this.variant === 'box-white') {
        setInterval(computeTime, 1000)
      }
    },
    addLeadingZero (digit) {
      if (typeof digit === 'number' && digit.toString().length === 1) {
        digit = '0' + digit
      }
      return digit
    }
  },
  validations () {
  }
}
</script>
